// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class AuthenticationIsEmailRegisteredAuthenticationIsEmailRegisteredDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AuthenticationIsEmailRegisteredAuthenticationIsEmailRegisteredDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return AuthenticationIsEmailRegisteredAuthenticationIsEmailRegisteredDefaultResponse.attributeTypeMap;
    }
}
